import React from "react";

export const NotFoundPage = (props) => {

    return (
        <div>
            NotFoundPage
        </div>
    );
};